import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { TOMOS, TOMO_FEATURES } from './salesData';
const TOMOS_IMG = 'https://cdn.magicpatterns.com/uploads/8CHHMxsjG8uTN596kv5bDs/MOCKUP.png';
export function TomosSection() {
  return <section id="tomos" className="bg-blush py-16 sm:py-24" data-id="element-256" data-mp="1u1lo7es8migf">
      <div className="mx-auto max-w-6xl px-5" data-id="element-257" data-mp="xce3ua3cufe3">
        <div className="text-center" data-id="element-258" data-mp="xdpd2pfkkfcl">
          <SectionTag data-id="element-259" data-mp="xeqoww4et5vd">🏆 MegaPack 6 en 1</SectionTag>
          <h2 className="mt-4 font-display text-3xl font-black leading-tight text-ink sm:text-5xl" data-id="element-260" data-mp="11er4ik38vn40">
            Estética Digital Pro™
          </h2>
          <p className="mt-3 text-lg text-ink/70" data-id="element-261" data-mp="1bc5kyjp64bwb">
            6 Tomos + 4 Bonos — Del perfil a la agenda llena
          </p>
          <p className="mt-1 font-display text-xl font-bold text-rose-deep" data-id="element-262" data-mp="2hsr5zzhqnktd">
            350+ páginas — Todo resuelto.
          </p>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-xl shadow-indigo-300/25 ring-1 ring-indigo-100" data-id="element-263" data-mp="2mphk4h9zg6c5">
          <img src={TOMOS_IMG} alt="Mega Pack Estética Digital Pro con los seis tomos y recursos incluidos" className="h-full w-full object-cover" data-id="element-264" data-mp="2mmnbqbn3y2es" />
        </div>

        <p className="mt-10 text-center text-sm font-semibold uppercase tracking-[0.2em] text-rose-deep" data-id="element-265" data-mp="2coponrgzibnr">
          📱 Perfil → Contenido → Cierre → Planificación
        </p>

        <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-266" data-mp="27rh1tdkw5jg6">
          {TOMOS.map((tomo, i) => <motion.article key={tomo.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="group rounded-2xl border border-rose/10 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg hover:shadow-rose/10" data-id="element-267" data-mp="1yx2fir1y18nk" data-mpi={i}>
              <span className="text-3xl" data-id="element-268" data-mp="1abejg507aqaj">{tomo.emoji}</span>
              <p className="mt-3 text-xs font-bold uppercase tracking-widest text-rose" data-id="element-269" data-mp="1fazj6hn732ob">{tomo.num}</p>
              <h3 className="mt-1 font-display text-xl font-bold text-ink" data-id="element-270" data-mp="11bri1j7h1khh">{tomo.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-271" data-mp="15d3bjztgupuy">{tomo.desc}</p>
            </motion.article>)}
        </div>

        <div id="incluye" className="mt-12 rounded-3xl border border-rose/10 bg-white p-6 shadow-sm sm:p-8" data-id="element-272" data-mp="1t3p6qqidgfnj">
          <h3 className="text-center font-display text-xl font-bold text-ink" data-id="element-273" data-mp="1y0fnlg203fa0">Cada tomo incluye:</h3>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-274" data-mp="1k9ubqbays5lm">
            {TOMO_FEATURES.map(f => <li key={f} className="flex items-start gap-2.5" data-id="element-275" data-mp="1oae7bafw315n">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-rose" data-id="element-276" data-mp="2c1076efqpf4k" />
                <span className="text-sm leading-relaxed text-ink/75" data-id="element-277" data-mp="2gs8ff75c2ug5">{f}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}